import revive_payload_client_YTGlmQWWT5 from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_neSs9z3UJp from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_VeD7Ba96AP from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_VTarsGAzgb from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_PKIXU5KmsI from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_LIYcCMJD18 from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_SeG0EjL5Ec from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/kwesterfeld/ybd/ui/portal/.nuxt/components.plugin.mjs";
import prefetch_client_8FoqvPFTot from "/home/kwesterfeld/ybd/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chart_client_a5LfFlCPUx from "/home/kwesterfeld/ybd/ui/shared/src/plugins/chart.client.js";
import floating_tdZmIJk62X from "/home/kwesterfeld/ybd/ui/shared/src/plugins/floating.ts";
import misc_iBQPI8jlgt from "/home/kwesterfeld/ybd/ui/shared/src/plugins/misc.ts";
import virtual_scroller_dnnCWqnzKw from "/home/kwesterfeld/ybd/ui/shared/src/plugins/virtual-scroller.ts";
import openreplay_client_L2Vni3uTBi from "/home/kwesterfeld/ybd/ui/portal/src/plugins/openreplay.client.ts";
export default [
  revive_payload_client_YTGlmQWWT5,
  unhead_neSs9z3UJp,
  router_VeD7Ba96AP,
  payload_client_VTarsGAzgb,
  navigation_repaint_client_PKIXU5KmsI,
  check_outdated_build_client_LIYcCMJD18,
  chunk_reload_client_SeG0EjL5Ec,
  components_plugin_KR1HBZs4kY,
  prefetch_client_8FoqvPFTot,
  chart_client_a5LfFlCPUx,
  floating_tdZmIJk62X,
  misc_iBQPI8jlgt,
  virtual_scroller_dnnCWqnzKw,
  openreplay_client_L2Vni3uTBi
]